import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import { AppState } from '../../../../../../../../types/store';
import { PapiUser } from '@wix/da-papi-types';
import { clickWatch } from '@wix/da-shared-react/pkg/WatchButton/redux/actionCreators';
import { getIsGroupMember } from '../../../../../../../selectors/groups';
import {
  getCanInviteToGroup,
  getCanChangeFounder,
  getCanLeaveGroup,
  getCanCloseGroup,
  getCanMessageAdmins,
  getCanRespondToNotifications,
} from '../../../../../../../selectors/privs';
import {
  inviteToGroup,
  requestCloseGroup,
  requestChangeFounder,
} from '../../../../../../../actions/groups';
import { requestLeaveGroup } from '@wix/da-shared-react/pkg/redux/groups/actions';
import { getProfileOwnerUser } from '../../../../../../../selectors/users';

import { Props } from './GroupMoreMenu';

export type StateProps = Pick<
  Props,
  | 'profileOwnerUser'
  | 'isGroupMember'
  | 'canInviteToGroup'
  | 'canMessageAdmins'
  | 'canChangeFounder'
  | 'canLeaveGroup'
  | 'canCloseGroup'
  | 'canRespondToGroupNotifications'
>;
export type DispatchProps = Pick<
  Props,
  | 'requestLeaveGroup'
  | 'requestChangeFounder'
  | 'showCloseGroupModal'
  | 'unwatchGroup'
  | 'inviteToGroup'
>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  AppState
> = state => ({
  isGroupMember: getIsGroupMember(state),
  canInviteToGroup: getCanInviteToGroup(state),
  canChangeFounder: getCanChangeFounder(state),
  canLeaveGroup: getCanLeaveGroup(state),
  profileOwnerUser: getProfileOwnerUser(state),
  canCloseGroup: getCanCloseGroup(state),
  canMessageAdmins: getCanMessageAdmins(state),
  canRespondToGroupNotifications: getCanRespondToNotifications(state),
});
const mapDispatchToProps: MapDispatchToProps<
  DispatchProps,
  OwnProps
> = dispatch => ({
  inviteToGroup: (group: PapiUser) => dispatch(inviteToGroup(group)),
  requestLeaveGroup: (group: PapiUser) => dispatch(requestLeaveGroup(group)),
  requestChangeFounder: (group: PapiUser) =>
    dispatch(requestChangeFounder(group)),
  showCloseGroupModal: (group: PapiUser) => dispatch(requestCloseGroup(group)),
  unwatchGroup: (group: PapiUser) => {
    dispatch(clickWatch(group, true));
  },
});

export default connect(mapStateToProps, mapDispatchToProps);
